/**
* Looping CTA JS
* -----------------------------------------------------------------------------
*
* All the JS for the Looping CTA component.
*/

/*
 * Example of importing modules if needed. Like for scroll magic / gsap
 */
import {gsap} from 'gsap';
import {ScrollTrigger} from 'gsap/ScrollTrigger.js';
gsap.registerPlugin( ScrollTrigger );
( function( app ) {
  const COMPONENT = {

    className: 'phone-cta',
    selector: function() {
      return '.' + this.className;
    },
    // Fires after common.init, before .finalize and common.finalize
    init: function() {
      function initAnimations() {
        const screenWidth = $( window ).width();

        if ( screenWidth >= 768 ) {
          gsap.utils.toArray( '.floating-left' ).forEach( ( floating ) => {
            gsap.fromTo( floating,
                {
                  opacity: 0,
                  y: 50,
                  x: -30,
                },
                {
                  opacity: 1,
                  y: -80,
                  x: -50,
                  scrollTrigger: {
                    trigger: floating,
                    start: 'top bottom',
                    end: 'bottom 70%',
                    scrub: true,
                    toggleActions: 'play none none reverse',
                  },
                },
            );
          } );

          // Right floating details
          gsap.utils.toArray( '.floating-right' ).forEach( ( floating ) => {
            gsap.fromTo( floating,
                {
                  opacity: 0,
                  y: 50,
                  x: 30,
                },
                {
                  opacity: 1,
                  y: -10,
                  x: 0,
                  scrollTrigger: {
                    trigger: floating,
                    start: 'top bottom',
                    end: 'bottom 70%',
                    scrub: true,
                    toggleActions: 'play none none reverse',
                  },
                },
            );
          } );
        } else {
        // Left floating details for mobile screens
          gsap.utils.toArray( '.floating-left' ).forEach( ( floating ) => {
            gsap.fromTo( floating,
                {
                  opacity: 0,
                  y: 50,
                  x: 0, // Center on mobile
                },
                {
                  opacity: 1,
                  y: 0,
                  x: 0,
                  scrollTrigger: {
                    trigger: floating,
                    start: 'top bottom',
                    end: 'bottom 70%',
                    scrub: true,
                    toggleActions: 'play none none reverse',
                  },
                },
            );
          } );

          // Right floating details for mobile screens
          gsap.utils.toArray( '.floating-right' ).forEach( ( floating ) => {
            gsap.fromTo( floating,
                {
                  opacity: 0,
                  y: 50,
                  x: 0, // Center on mobile
                },
                {
                  opacity: 1,
                  y: 0,
                  x: 0,
                  scrollTrigger: {
                    trigger: floating,
                    start: 'top bottom',
                    end: 'bottom 70%',
                    scrub: true,
                    toggleActions: 'play none none reverse',
                  },
                },
            );
          } );
        }
      }
      // Initialize animations on page load
      initAnimations();

      const throttledUpdateAnimation = new app.components.common.Debounce( initAnimations, 250 );
      // Re-initialize animations on window resize
      $( window ).resize( function() {
        throttledUpdateAnimation.run();
      } );
    },
    finalize: function() {
    },
  };

  // Hooks the component into the app
  app.registerComponent( 'phone-cta', COMPONENT );
} )( app );
